import {ViewTypeVo} from '../../common/shared/api/karina/vo/enums/ViewTypeVo.enum';
import type {RankingThemeStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/RankingThemeStaticLandingPageVo.interface';
import {
  GroupType,
  LayoutType,
  type Maybe,
  SectionType,
  type StaticLandingRankingThemeParamInput,
  type StaticLandingRankingThemeSection,
  StaticLandingType,
  type User,
} from '../generated/types';
import {createItem} from './Item';
import {createPromotionBannerItem} from './PromotionBannerItem';
import {createSortOption} from './SortOption';
import {createStaticLandingRankingThemeSectionParam} from './StaticLandingRankingThemeSectionParam';

export function createStaticLandingRankingThemeSection(
  userInfo: Maybe<User>,
  {
    sectionId,
    rankingThemeStaticLandingPageVo: vo,
    input,
    type = LayoutType.Landing,
  }: {
    sectionId?: string;
    rankingThemeStaticLandingPageVo: RankingThemeStaticLandingPageVo;
    input: StaticLandingRankingThemeParamInput;
    type?: Maybe<LayoutType>;
  }
): StaticLandingRankingThemeSection {
  const param = createStaticLandingRankingThemeSectionParam(vo, input);
  const isSeriesCardView = vo.view_type === ViewTypeVo.SeriesCardView;

  return {
    id:
      sectionId ||
      `static-landing-${StaticLandingType.RankingTheme}-section-${type}-${
        input.screenUid ?? 'unknown'
      }-${param.filterType ?? 'all'}-${param.sortType ?? 'popular'}`,
    type: SectionType.LandingRankingTheme,
    groups: [
      {
        id: `static-landing-${StaticLandingType.RankingTheme}-group-${
          input.screenUid ?? 'unknown'
        }-${param.filterType ?? 'all'}-${param.sortType ?? 'popular'}`,
        type: isSeriesCardView ? GroupType.CardView : GroupType.PosterView,
        items:
          vo.list?.map((item, index) =>
            createItem(userInfo, {
              viewItemVo: {
                viewItem: item,
                viewType: isSeriesCardView
                  ? ViewTypeVo.SeriesCardView
                  : ViewTypeVo.SeriesPosterView,
                sectionType: SectionType.LandingRankingTheme,
              },
              index: (input.page ?? 0) * 50 + index,
            })
          ) || [],
      },
    ],
    filterOptList:
      vo.filter_opt_list?.map(opt => createSortOption({sortOptVo: opt})) || [],
    selectedFilterOpt: vo.selected_filter_opt
      ? createSortOption({sortOptVo: vo.selected_filter_opt})
      : undefined,
    rankSortOptList:
      vo.rank_sort_opt?.map(opt => createSortOption({sortOptVo: opt})) || [],
    selectedRankSortOpt: vo.selected_rank_opt
      ? createSortOption({sortOptVo: vo.selected_rank_opt})
      : undefined,
    isEnd: vo.is_end,
    rankingTime: vo.ranking_time,
    rankingDt: vo.ranking_dt,
    title: vo.title,
    totalCount:
      input.page === 0 || input.page === undefined
        ? vo.list?.length
        : undefined,
    /**
     * 단행본 랭킹 테마는 서브탭(Layout)/고정 랜딩(Landing) 모두 섹션 내부에서 프로모션 배너를 그린다.
     * 별도 PromotionBannerSection 으로 분리하지 않는다.
     */
    promotionBanner: vo.section_promotion_banner
      ? createPromotionBannerItem(vo.section_promotion_banner)
      : undefined,
    viewType: vo.view_type,
    param,
  };
}
